import React from "react";
import { useInViewOnce } from "@/lib/useInViewOnce";

const LINES = [
  [{ w: "WE" }, { w: "DON'T" }, { w: "JUST" }, { w: "MAKE" }, { w: "IT" }, { w: "LOOK" }, { w: "GOOD." }],
  [{ w: "WE" }, { w: "MAKE" }, { w: "IT" }, { w: "MATTER.", accent: true }],
];

export const KineticStatement = () => {
  const [ref, inView] = useInViewOnce(0.3);
  let i = 0;
  return (
    <section data-testid="kinetic-statement" className="bg-[#0F0F0F] pt-8 sm:pt-12 pb-2 sm:pb-4 overflow-hidden">
      <div
        ref={ref}
        className={`ur-kinetic max-w-[1400px] min-[1440px]:max-w-[1720px] mx-auto px-4 sm:px-6 lg:px-10 min-[1440px]:px-[clamp(2.5rem,4vw,4rem)]${inView ? " is-in" : ""}`}
      >
        <h2 className="font-display font-black uppercase tracking-tight leading-[0.95] text-[40px] sm:text-6xl lg:text-[84px] min-[1440px]:text-[104px]">
          {LINES.map((line, li) => (
            <span key={li} data-testid={`kinetic-line-${li + 1}`} className={`block ${li === 0 ? "text-[#5C5C5C] ur-kinetic-line1" : "text-white"}`}>
              {line.map(({ w, accent }) => {
                const d = (i += 1) * 70;
                return (
                  <React.Fragment key={`${li}-${w}-${d}`}>
                    <span
                      className={`ur-kinetic-word${accent ? " ur-kinetic-accent" : ""}`}
                      style={{ "--d": `${d}ms` }}
                    >
                      {w}
                    </span>{" "}
                  </React.Fragment>
                );
              })}
            </span>
          ))}
        </h2>
      </div>
    </section>
  );
};
